import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// Icons
import { AiOutlineSearch } from "react-icons/ai";

// Components
import Spinner from "../Components/Spinner";
import PaginatedTableImports from "../Components/Tables/Customs/PaginatedTableImports";

// Services
import { importService } from "../../Services/import.service";
import { importTypeService } from "../../Services/import.type.service";
import { toDateISOString } from "../../Services/string.service";

// Constants
const _pageTitle = "Arquivos importados";
const _listTitle = "Lista de importações";

export default function Imports() {
	const [isLoading, setIsLoading] = useState(false);
	const [importTypesItems, setImportTypesItems] = useState([]);
	const [importItems, setImportItems] = useState([]);
	const [defaultDateStart] = useState(
		toDateISOString(new Date(new Date().setMonth(new Date().getMonth() - 1)))
	);
	const [dateStart, setDateStart] = useState(
		new Date(new Date().setMonth(new Date().getMonth() - 1))
	);
	const [defaultDateEnd] = useState(
		toDateISOString(new Date(new Date().setDate(new Date().getDate() + 1)))
	);
	const [dateEnd, setDateEnd] = useState(
		new Date(new Date().setDate(new Date().getDate() + 1))
	);
	const [fileDestination, setFileDestination] = useState("");

	const dispatch = useDispatch();
	dispatch({ type: "title", value: _pageTitle });

	const onFilter = async () => {
		if (fileDestination) {
			setIsLoading(true);
			setImportItems(
				await importService.fetchByType(fileDestination, dateStart, dateEnd)
			);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		const initialize = async () => {
			setIsLoading(true);
			setImportTypesItems(await importTypeService.fetch());
			setIsLoading(false);
		};

		initialize();
	}, []);

	return (
		<>
			<div className="container-xxl flex-grow-1 container-p-y">
				{isLoading ? <Spinner /> : ""}

				<div
					className="card"
					style={isLoading ? { display: "none" } : { display: "" }}
				>
					<div className="d-flex justify-content-between">
						<div className="p-2 card-header">
							<h5>{_listTitle}</h5>
						</div>
					</div>
					<div className="p-2">
						<div className="row align-items-start">
							<div className="col-sm-3">
								<label htmlFor="defaultSelect" className="form-label">
									Filtrar por destino de arquivos
								</label>
								<select
									name="fileType"
									onChange={async (e) => setFileDestination(e.target.value)}
									className="form-control"
								>
									<option value="">--Destino de arquivos--</option>
									{importTypesItems &&
										importTypesItems.map((item, index) => (
											<option key={index} value={item.scheduleTypeId}>
												{item.name}
											</option>
										))}
								</select>
							</div>

							<div className="col-sm-2">
								<label htmlFor="defaultSelect" className="form-label">
									Filtrar por data inicial
								</label>
								<input
									type="date"
									id="start"
									className="form-control"
									defaultValue={defaultDateStart}
									onChange={(e) => setDateStart(e.target.value)}
								></input>
							</div>

							<div className="col-sm-2">
								<label htmlFor="defaultSelect" className="form-label">
									Filtrar por data final
								</label>
								<input
									type="date"
									id="end"
									className="form-control"
									defaultValue={defaultDateEnd}
									onChange={(e) => setDateEnd(e.target.value)}
								></input>
							</div>

							<div className="col-sm-3" style={{ marginTop: "28px" }}>
								<div style={{ paddingRight: "5px" }}>
									<button
										type="button"
										className="btn btn-primary"
										disabled={!fileDestination}
										onClick={onFilter}
									>
										<AiOutlineSearch className="icon-in-button" />
										Buscar
									</button>
								</div>
							</div>
						</div>
					</div>

					<PaginatedTableImports
						data={importItems}
						pageSize={10}
						columns={["Id", "Nome", "Data", "Status"]}
						fields={["scheduleFileId", "fileName", "created", "statusId"]}
					/>
				</div>
			</div>
		</>
	);
}
